// process.env shim for browser dev. Vite's `define` config substitutes
// `process.env.REACT_APP_*` at build time on Railway / CI builds, but in local
// dev the substitution can miss for source files served as raw modules. This
// shim makes `process.env.REACT_APP_*` work at runtime without changing every
// reference. import.meta.env is always populated by Vite when REACT_APP_* /
// VITE_* names are in scope (see vite.config.ts envPrefix).
if (typeof globalThis.process === "undefined") {
  globalThis.process = { env: { ...import.meta.env } };
}

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BRAND_TITLE, BRAND_META_DESCRIPTION } from "./config/brand";

// Stale-chunk self-heal (blank-page incident, 2026-07-26): when a deploy swaps bundles
// while a session is open, React.lazy imports reference purged chunk hashes and reject —
// stranding the user. Vite fires `vite:preloadError` for exactly this; one automatic
// reload fetches the fresh index.html. Guarded to a single attempt per navigation so a
// genuinely broken deploy can't reload-loop.
window.addEventListener("vite:preloadError", (event) => {
  const KEY = "cs-chunk-reload-at";
  const last = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - last > 10000) {
    sessionStorage.setItem(KEY, String(Date.now()));
    event.preventDefault();
    window.location.reload();
  }
});

// Product name is a single source of truth (src/config/brand.ts). Set the
// document title + meta description from it at boot so the eventual rename is a
// one-line change and the retired "ClaimSync" trademark never ships in the tab.
document.title = BRAND_TITLE;
const metaDescription = document.querySelector('meta[name="description"]');
if (metaDescription) {
  metaDescription.setAttribute("content", BRAND_META_DESCRIPTION);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
